import Signature from '@nollaSdk/models/Signature'
import { ADD_ITEM_TO_LIST, SET_ITEM } from '../core/mutation-types'
import mutations from '../core/mutations'

const state = {
  initialState() {
    return {
      list: [],
      item: null,
    }
  },
  list: [],
  item: null,
}

// actions
const actions = {
  get({ commit }, id) {
    return Signature.find(id)
      .then(model => {
        commit(SET_ITEM, model)
        if (model) {
          commit(ADD_ITEM_TO_LIST, model)
        }
        return model
      })
  },
  putSign({ commit }, id) {
    return Signature.putSign(id)
      .then(model => {
        commit(SET_ITEM, model)
        if (model) {
          commit(ADD_ITEM_TO_LIST, model)
        }
        return model
      })
  },
}

export default {
  actions,
  mutations,
  namespaced: true,
  state,
}
